import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export type UserUpdate = {
  firstName: string;
  lastName: string;
  position: string;
};

export const useUpdateUser = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: UserUpdate) =>
      apiClient.onboarding.submitUserData({
        requestBody: {
          first_name: requestBody.firstName,
          last_name: requestBody.lastName,
          position: requestBody.position,
        },
      }),
  });

  const { mutate, mutateAsync, ...rest } = mutation;

  return {
    ...rest,
    updateUser: mutate,
    updateUserAsync: mutateAsync,
  };
};
